/**
 * @generated SignedSource<<1dd021ab2e41942c1e8f734ac791339f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type auth_checkAuthForPage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"auth_getRedirectPath">;
  readonly " $fragmentType": "auth_checkAuthForPage";
};
export type auth_checkAuthForPage$key = {
  readonly " $data"?: auth_checkAuthForPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"auth_checkAuthForPage">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "auth_checkAuthForPage"
};

(node as any).hash = "3330d67d6b8084e14a4e6d41d8d45c61";

export default node;
